import { Component, Input, Optional, ElementRef } from '@angular/core';
import { OnInit, OnDestroy } from '@angular/core';
import { UserService } from '../../../user.service';
import { FormConfig } from '../../forms/form.objects';
import { UserPrefs, MainViewPrefs } from '../../../api/UserPrefs-dto';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/AppState';
import { BaseComponent } from '../baseComponent/base.component';
import { SET_USERPREFS } from '../../../store/userPrefs';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';

@Component({
  selector: 'plyca-helpElementResult',
  templateUrl: 'helpElementResult.template.html'
})
export class HelpElementResultComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input()
  searchTags: Array<string>;
  @Input()
  groupedHelp: Array<any>;
  formConfig: FormConfig;
  isModal = false;

  userPrefs: UserPrefs;

  constructor(
    @Optional() public ref: DynamicDialogRef,
    @Optional() public dialogConfig: DynamicDialogConfig,
    public userService: UserService,
    private el: ElementRef,
    private store: Store<AppState>
  ) {
    super();
    this.subscribe(this.store
      .select('userPrefs'),
      (prefs: UserPrefs) => {
        this.userPrefs = prefs;

        if (!this.userPrefs.mainViewPrefs) {
          this.userPrefs.mainViewPrefs = new MainViewPrefs();
        }
      });

    // Si es un formplyca  modal
    if (this.dialogConfig['formConfig'] !== undefined) {

      this.formConfig = this.dialogConfig['formConfig'];
      this.searchTags = this.formConfig['searchTags'];
      this.groupedHelp = this.formConfig['groupedHelp'];

    } else if (this.dialogConfig !== undefined && dialogConfig['searchTags'] !== undefined) {
      this.searchTags = dialogConfig['searchTags'];
      this.groupedHelp = dialogConfig['groupedHelp'];
      this.isModal = true;
    }


    console.log('HELP ELEMENT RESULT  this.searchTags' + this.searchTags);
    console.log('HELP ELEMENT RESULT  this.searchTags' + this.searchTags);

  }

  showHelpTags() {
    return this.searchTags && this.userService.hasRoles('0,50')
      && this.userPrefs && this.userPrefs.mainViewPrefs && this.userPrefs.mainViewPrefs.showHelpTags;
  }

  ngOnInit() { }

  ngOnDestroy() {
    this.dialogConfig = null;
    this.ref = null;
    let thisUserPrefs = this.userPrefs;
    this.store.dispatch(SET_USERPREFS({ userPrefs: thisUserPrefs }));
    super.ngOnDestroy();
  }

  isFormFieldHelp() {
    return this.searchTags && this.groupedHelp && this.searchTags.find(entry => entry.startsWith('FLD_'))
      && this.groupedHelp.length === 1 && this.groupedHelp[0]['groupId'] === 'AYUDA';
  }

  close() {
    this.ref.close();
  }
}
